import { 
  Palette, 
  Users,
  Terminal,
  Send,
  Zap,
  Star,
  Shield,
  Server,
  Cloud,
  Monitor
} from "lucide-react";
// Stable public assets for performance (no Vite hashes)
const mythicalImg = "/mythicalsystems.webp";
const featherImg = "/featherpanel.webp";
const gamsterImg = "/gamster.webp";
const avatarImg = "/avatar.webp";
const backgroundMp4 = "/background.mp4";
const radioImg = "/radio.avif";

// Testimonials Data

export const profileData = {
  name: "Nayskutzu",
  fullName: "Cassian Gherman",
  role: "Lead System Admin & Full-stack Architect",
  discord: "nayskutzu",
  bio: "Mastering the chaos of complex systems and elegant code. From deep-level Linux kernel optimizations and Windows Server orchestration to architecting high-scale Laravel and Next.js ecosystems. I bridge the gap between robust infrastructure and premium user experiences.",
  avatarSrc: avatarImg,
  bannerSrc: backgroundMp4,
  email: "nayskutzu@mythical.systems",
  location: "Europe",
  available: true,
  rate: "€20/hr",
  duration: "24/7",
  rating: 5.0,
  glowText: "Orchestrating Digital Excellence",
  contactButton: {
    label: "Get in touch",
    href: "mailto:nayskutzu@mythical.systems"
  },
  connectButton: {
    label: "Connect",
    href: "https://www.linkedin.com/in/cassian-gherman-5107ab2b4/"
  }
};

export const toolsData = [
  { id: "linux", icon: Terminal, label: "Linux / Kernel" },
  { id: "windows", icon: Monitor, label: "Windows Server / AD" },
  { id: "cloud", icon: Cloud, label: "Cloud Infra / K8s" },
  { id: "backend", icon: Server, label: "PHP / Laravel / Go" },
  { id: "frontend", icon: Palette, label: "React / Vue / Next" },
  { id: "security", icon: Shield, label: "Cyber Security" },
];

export const socialLinks = [
  { platform: "GitHub", icon: Terminal, href: "https://github.com/nayskutzu" },
  { platform: "Twitter", icon: Send, href: "https://twitter.com/nayskutzuftw" },
  { platform: "LinkedIn", icon: Users, href: "https://www.linkedin.com/in/cassian-gherman-5107ab2b4/" },
  { platform: "Instagram", icon: Zap, href: "https://instagram.com/not.nays.kutzu" },
  { platform: "Discord", icon: Star, href: "https://discord.mythical.systems" }, 
];

export const projectsData = [
  {
    id: 1,
    title: "MythicalSystems",
    category: "Fullstack & System Admin",
    description: "MythicalSystems is the main place i work at. We provide high-quality hosting and infrastructure management services to our clients.",
    imageSrc: mythicalImg,
    tools: ["Linux", "Development", "NextJs", "Php"],
    href: "https://mythical.systems"
  },
  {
    id: 2,
    title: "FeatherPanel",
    category: "Fullstack Developer",
    description: "FeatherPanel is a free and open-source game server control panel. It is a modern, lightweight, and easy-to-use control panel for managing game servers.",
    imageSrc: featherImg,
    tools: ["PHP", "Rust", "NextJS", "Go"],
    href: "https://featherpanel.com"
  },
  {
    id: 3,
    title: "Gamster",
    category: "Developer",
    description: "Gamster.org is one of the biggest Minecraft servers in the world. Peaking at over 1 to 2 thousand concurrent players. And i have and curently help maintain server.",
    imageSrc: gamsterImg,
    tools: ["Java"],
    href: "https://gamster.org"
  },
];

export const faqData = [
  {
    id: "01",
    title: "What systems do you specialize in?",
    content: "I have extensive experience managing both Linux (Debian, RHEL, Ubuntu) and Windows Server ecosystems. I handle everything from Active Directory and GPO to automated Linux kernel hardening and Docker/K8s orchestration."
  },
  {
    id: "02",
    title: "Tell me about your development stack.",
    content: "I am polyglot developer. I build custom high-performance frameworks in PHP, manage modern apps with Laravel/Next.js/Vue, and write performance-critical logic in Rust, Go, or Java."
  },
  {
    id: "03",
    title: "How do you handle security?",
    content: "Security is baked into my workflow. Whether it's setting up firewall rules, implementing OAuth2/OIDC, or performing penetration tests on custom code, I ensure every layer is protected."
  },
  {
    id: "04",
    title: "What's the 'Mythical' connection?",
    content: "I am the founder of Mythical Systems, where we push the boundaries of what's possible in hosting and infrastructure automation. It's my base of operations for high-end digital solutions."
  }
];

export const musicData = {
  title: "Mythical FM Radio",
  artist: "Live Stream",
  cover: radioImg,
  streamUrl: "https://fm.mythical.systems/listen/mythicalfm/radio.mp3"
};

export const testimonialsData = [
  {
    text: "FeatherPanel redefined our infrastructure experience - lightning fast, feather-light on resources, and astonishingly intuitive. Built by people who actually understand hosting.",
    name: "Galaxy OP",
    role: "CEO, Blazars Cloud",
  },
  {
    text: "Nothing comes close to FeatherPanel's modern design and seamless performance. Deployment is effortless, and our clients love the experience every time.",
    name: "Blanco",
    role: "Cloud Architect",
  },
  {
    text: "How am I only just finding this panel? It works perfectly, looks amazing, and the developer actually ships updates. Rare combination in this space.",
    name: "Adam",
    role: "Founder, ONHost",
  },
  {
    text: "We switched after months of frustration. Migration was smooth, support excellent, and operations have never run better.",
    name: "ChristiannX",
    role: "Founder, MultyPlay & ScrifySystems",
  },
  {
    text: "Robust features, modern security, true reliability. This is the upgrade I wish we'd made two years earlier.",
    name: "Alexutzerion5",
    role: "Founder, RexSystems & Lethal Romania",
  },
  {
    text: "Light, responsive, and genuinely next-gen. Managing game servers, VMs, and websites from one panel is something I didn't know I needed.",
    name: "Th3Hunter",
    role: "Founder, KingsDomain",
  },
  {
    text: "The performance gain we saw after switching to Nayskutzu's builds was immediate. 40% less overhead on our Linux nodes.",
    name: "Zeno",
    role: "System Engineer",
  },
  {
    text: "Finally, a developer who prioritized both performance and UI. FeatherPanel is the gold standard for game hosting panels now.",
    name: "Kyra",
    role: "Fullstack Developer",
  },
  {
    text: "Elite security and top-tier support. If you're running enterprise apps, this is the infrastructure you need.",
    name: "Mark J.",
    role: "Tech Lead",
  },
];
